import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components'
import { setEmailResultsModal } from '../../actions/modals';
import { useSendCaseResultsEmail } from '../../hooks/editors';
import { showEmailResultsSelector } from '../../selectors/modals';
import { emailSelector } from '../../selectors/entities';
import { Button } from './Common';
import { Modal } from './Modal';
import { Formik } from 'formik';
import { validateEmails } from '../../utils/validators';
import { TextField } from './FormFields';

const Title = styled.h3`
  font-weight: 800;
  font-size: 21px;
  margin-top: 10px;
`

const Text = styled.p`
  margin: 20px 0px;
`

export const EmailResultsModal = () => {

  const showModal = useSelector(showEmailResultsSelector);
  const dispatch = useDispatch();
  const onClose = () => dispatch(setEmailResultsModal(false));
  const initEmail = useSelector(emailSelector)

  const [submit, submitting] = useSendCaseResultsEmail(onClose);

  if (!showModal) {
    return null;
  }

  return (
    <Formik
      validate={validateEmails}
      initialValues={{ email: initEmail || '' }}
      onSubmit={submit}>
      {({ handleSubmit, errors, touched, values, submitCount }) => {
        const getError = (name) => (touched[name] || submitCount >= 1) && errors[name];
        return (
          <Modal closeOnOuterClick={true} onClose={onClose} style={{ width: 'min(95%, 550px)' }}>
            <Title>Send Email</Title>
            <Text style={{marginBottom: '10px'}}>
              Enter the email that you'd like to send your case results to. 
            </Text>
            <Text style={{marginTop: '10px'}}>
              Please note that this email will contain <b>detailed information about your cases</b>, 
              so <b>double check</b> that you have entered the correct email.
            </Text>
            <TextField name="email" placeholder="example@gmail.com" error={getError("email")} />
            <Button isLoading={submitting} onClick={handleSubmit}>Send email</Button>
          </Modal>
        )}}
    </Formik>
  )
}